import { render, staticRenderFns } from "./Abba.vue?vue&type=template&id=3ae0b0b7&scoped=true&lang=pug&"
import script from "./Abba.vue?vue&type=script&lang=js&"
export * from "./Abba.vue?vue&type=script&lang=js&"
import style0 from "./Abba.vue?vue&type=style&index=0&id=3ae0b0b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae0b0b7",
  null
  
)

export default component.exports